export default __webpack_public_path__ + "static/media/part_1_img.1236ee52.png";